module.exports = __webpack_public_path__ + "img/credit-card.86895e19.svg";